<script setup lang="ts">
import type { TextVariants } from '.'
import { textVariants } from '.'
import { cn } from '../../lib/utils'
import type { HTMLAttributes } from 'vue'

const { tag = 'p', class: className } = defineProps<{
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'label'
  size?: TextVariants['size']
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <component
    :is="tag"
    :class="cn(textVariants({ size }), className)"
  >
    <slot />
  </component>
</template>
